import { useEffect, useState } from "react";
import logo from "/src/assets/Fight Less-Win More Icon 75px.svg";
import lightIcon from "/src/assets/Fight Less-Win More Icon 75px.svg";
import { useTheme } from "@mui/material/styles";

interface LoadingSpinnerProps {
  text?: string;
  size?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  text = "Loading",
  size = 120,
}) => {
  const ringRadius = size * 0.45;
  const logoSize = size * 0.67 - 10;
  const [dotCount, setDotCount] = useState(0);
  const [displayText, setDisplayText] = useState(text);
  const theme = useTheme();

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4); // cycles: 0, 1, 2, 3
    }, 400);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Reset display text when prop text changes
    setDisplayText(text);
    
    // Set up timer for "Thinking" text
    if (text === "Thinking") {
      const timer = setTimeout(() => {
        setDisplayText("Diving Deeper");
      }, 10000); // 10 seconds
      
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [text]);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
      <div style={{ position: "relative", width: size, height: size }}>
        <svg
          style={{ position: "absolute", top: 0, left: 0, zIndex: 1 }}
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
        >
          <ellipse
            cx={size / 2}
            cy={size / 2}
            rx={ringRadius}
            ry={ringRadius}
            stroke="#e50c20"
            strokeWidth={size * 0.04}
            fill="none"
          >
            <animate
              attributeName="rx"
              values={`${ringRadius};0;${ringRadius}`}
              dur="1.6s"
              repeatCount="indefinite"
            />
          </ellipse>
        </svg>
        <img
          src={theme.palette.mode === 'light' ? logo : lightIcon}
          alt="JBS Logo"
          style={{
            width: logoSize,
            height: logoSize,
            objectFit: "contain",
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
          }}
        />
      </div>
      <div style={{ marginTop: size * 0.1, fontSize: size / 5.5, fontWeight: 600, color: "#e50c20", textAlign: "center" }}>
        {displayText}
        <span>
          {'.'.repeat(dotCount)}
          <span style={{ opacity: 0 }}>{'.'.repeat(3 - dotCount)}</span>
        </span>
      </div>
    </div>
  );
};

export default LoadingSpinner;